import { render, staticRenderFns } from "./floating-label.vue?vue&type=template&id=c18ff8cc&"
import script from "./floating-label.vue?vue&type=script&lang=ts&"
export * from "./floating-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports